import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { delay, first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { FormBaseComponent } from '../../../../../../src/app/shared/components/form/form.component';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { HelperService } from "../../../../../../src/app/services/helper/helper.service";
import { BannerService } from '../../../../../../src/app/shared/services/banner.service';



import { AldAnonymousState } from "../../../../../../src/app/services/ald-anonymous/ald-anonymous.state";
import * as AldAnonymousActions from "../../../../../../src/app/services/ald-anonymous/ald-anonymous.action";
import * as GarageVisitsModels from '../../../../../../src/app/models/garage-visits/garage-visits';
import * as GarageModels from '../../../../../../src/app/models/garage/garage';
import * as CarModels from "../../../../../../src/app/models/car/car";
import * as CarTypeModels from '../../../../../../src/app/models/car/carType';

@Component({
    selector: 'app-garage-visit-confirmation',
  templateUrl: './garage-visit-confirmation.component.html',
  styleUrls: ['./garage-visit-confirmation.component.scss']
})

export class GarageVisitConfirmationComponent extends FormBaseComponent implements OnInit {


  public garageVisitId: number;

  public garageVisit: GarageVisitsModels.GarageVisitModel;

  public garageVisitRequest: Models.RequestModel;

  @Select(AldAnonymousState.GarageVisit)
  GarageVisit$: Observable<Models.Response<GarageVisitsModels.GarageVisitModel>>;



  


  constructor(
        private formBuilder: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public store: Store,
        public helperService: HelperService,
        public environmentService: EnvironmentService,
        public changeDetectorRef: ChangeDetectorRef,
        public activatedRoute: ActivatedRoute,
        public bannerService: BannerService
    ) {

    super(helperService, environmentService, changeDetectorRef);

    }

  ngOnInit() {

    this.subscription.add(this.GarageVisit$.subscribe((data) => {
      if (data && data.Success && this.garageVisitRequest && this.garageVisitRequest.RequestSignature == data.RequestSignature) {
        this.garageVisit = data.Item;
      }
    }));

    this.activatedRoute.paramMap.subscribe(params => {
      this.garageVisitId = +params.get('id');

      if (this.garageVisitId && !this.garageVisit) {

        this.garageVisitRequest = new Models.RequestModel(this.garageVisitId);

        this.store.dispatch(new AldAnonymousActions.GetGarageVisit(this.garageVisitRequest));
      }
    });
  }
}
